import React, { useState, useEffect } from "react";

const BooksUsageTable = ({ lstUsage }) => {
    const [lstUsageFiltered, setLstUsageFiltered] = useState([]);
    const [classFiltered, setClassFiltered] = useState("");
    const [studentFiltered, setStudentFiltered] = useState("");

    useEffect(() => {
        setClassFiltered("");
        setStudentFiltered("");
        setLstUsageFiltered(lstUsage);
    }, [lstUsage]);

    const handleFilterClass = (value) => {
        setClassFiltered(value);
        filterTable(value, studentFiltered);
    };

    const handleFilterStudent = (value) => {
        setStudentFiltered(value);
        filterTable(classFiltered, value);
    };

    const filterTable = (classVal, studentVal) => {
        let filtered = lstUsage;
        if (classVal && classVal.trim() !== "") {
            filtered = filtered.filter(item =>
                item.cls.toLowerCase().includes(classVal.trim().toLowerCase())
            );
        }
        if (studentVal && studentVal.trim() !== "") {
            filtered = filtered.filter(item =>
                item.student.toLowerCase().includes(studentVal.trim().toLowerCase())
            );
        }
        setLstUsageFiltered(filtered);
    };

    const colgrp = (
        <colgroup>
            <col width="80" />
            <col width="80" />
            <col width="160" />
            <col width="80" />
            <col width="80" />
        </colgroup>
    );

    return (
        <div className="col-sm-12 padding-remove">
            <div className="col-sm-12 padding-remove">
                <table className="tableLayout1">
                    {colgrp}
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={classFiltered}
                                    onChange={e => handleFilterClass(e.target.value)}
                                    placeholder="Class"
                                />
                            </th>
                            <th>Section</th>
                            <th>
                                <input
                                    type="text"
                                    className="form-control inp-search"
                                    value={studentFiltered}
                                    onChange={e => handleFilterStudent(e.target.value)}
                                    placeholder="Student"
                                />
                            </th>
                            <th>Complete (%)</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "60vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody>
                            {lstUsageFiltered.length > 0 ? (
                                lstUsageFiltered.map((item) => (
                                    <tr key={item.studentId + "-" + item.sectionId + "-" + item.clsId}>
                                        <td className="text-left">{item.cls}</td>
                                        <td className="text-center">{item.section}</td>
                                        <td className="text-left">{item.student}</td>
                                        <td className="text-center">{item.completePct}</td>
                                        <td className="text-center">{item.timeSpent}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={5} className="text-center">No records found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default BooksUsageTable;